export default "__VITE_ASSET__4fe7f259__"